<button
  class="copy-button"
  (click)="onCopy()"
  [sgTooltip]="tooltipMessage"
  [tooltipOpen]="isTooltipVisible"
  [tooltipPosition]="'above'"
  [tooltipShowDelay]="0"
  [tooltipArrow]="'none'"
  [tooltipHideDelay]="0">
  <mat-icon>content_copy</mat-icon>
</button>
